module.exports = __webpack_public_path__ + "static/lamsar-logo-826ec8d066d2a4362a0dd0b2bd22ab19.png";